import { render, staticRenderFns } from "./Fullscreen.vue?vue&type=template&id=da8ceae0&scoped=true&"
import script from "./Fullscreen.vue?vue&type=script&lang=ts&"
export * from "./Fullscreen.vue?vue&type=script&lang=ts&"
import style0 from "./Fullscreen.vue?vue&type=style&index=0&id=da8ceae0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da8ceae0",
  null
  
)

export default component.exports